import React, { useEffect } from 'react'
import { DataCounter } from '../../../../ui/data-counter/data-counter-component'
import { usersHeaderStyles } from '../header/users-header.styles'
import { counterSkeletonStyles, skeletonAnimationStyles } from './users-status-counters.styles'
import { useUsersContext } from '../../contexts'

export const UsersStatusCountersComponent = () => {
  const { statusCount, getStatusCount, statusCountLoading } = useUsersContext()

  useEffect(() => {
    getStatusCount()
  }, [])

  return (
    <>
      <style>{skeletonAnimationStyles}</style>
      
      <div style={counterSkeletonStyles.getContainerStyle(usersHeaderStyles.dataCounterContainer)}>
        
        {statusCountLoading ? (
          <div 
            className="skeleton-pulse-active" 
            style={counterSkeletonStyles.skeletonBoxFallback} 
          />
        ) : (
          <>
            <div style={counterSkeletonStyles.counterWrapper}>
              <DataCounter title="CONFIRMED" value={statusCount?.confirmed || 0} titleColor="success" />
            </div>

            <div style={counterSkeletonStyles.counterWrapper}>
              <DataCounter title="RESET_REQUIRED" value={statusCount?.reset_required || 0} titleColor="warning" />
            </div>

            <div style={counterSkeletonStyles.counterWrapper}>
              <DataCounter title="UNCONFIRMED" value={statusCount?.unconfirmed || 0} titleColor="error" />
            </div>
          </>
        )}

      </div>
    </>
  )
}